import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { resourceId: Number , time: String }
  static targets = ["form"]

  connect() {
    this.scheduleRedirect();
  }

  scheduleRedirect() {
    const [hours, minutes] = this.timeValue.split(":").map(Number);
    const now = new Date();
    const redirectTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);

    if (redirectTime <= now) {
      redirectTime.setDate(redirectTime.getDate() + 1);
    }

    const delay = redirectTime - now;

    setTimeout(() => {
      const formData = new FormData(this.formTarget);
      const csrfToken = document.querySelector("[name='csrf-token']").content;
      fetch(`/course_completion_test_take_exams/auto_complete/${this.resourceIdValue}`, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': csrfToken
        }
      }).then(response => response.json())
        .then(data => {
          if(data.redirect_url) {
            window.location.href = data.redirect_url;
          }
      })
    }, delay);
  }
}